export interface BranchDropdownActionType {
  type: BranchDropdown;
  payload?: any;
}

export enum BranchDropdown {
  GET_BRANCH_DROPDOWN_LIST = "GET_BRANCH_DROPDOWN_LIST",
  SET_BRANCH_DROPDOWN_LIST = "SET_BRANCH_DROPDOWN_LIST",
  SET_BRANCH_DROPDOWN_LOADING = "SET_BRANCH_DROPDOWN_LOADING",
}
